import React from 'react'
import { Link } from 'react-router-dom'
import { Pill, NotAvailable } from '@myxplor/ui'
import { conditionalLink } from '../../conditional-link'
import { truncateDay } from '../../week'
import { days, activeCase } from '../helpers'

const govRecord = ({ gov_record = {} }, attr) =>
  gov_record[attr] ? gov_record[attr] : <NotAvailable name={attr} />

export const ISSCaseClaimListItem = ({ record, path, selected = false }) => (
  <div className="listItemContent">
    <div>
      {conditionalLink(
        !selected,
        <Link to={path}>
          <div className="listItemContent--heading">{record.gov_id}</div>
        </Link>
      )}
      <dl className="listItemContent--details">
        <li>{govRecord(record, 'Type')}</li>
        <li>Start {govRecord(record, 'StartDate')}</li>
        <li className="listItemContent--pills">
          {days(record).map((day, i) => <Pill key={i}>{truncateDay(day)}</Pill>)}
        </li>
      </dl>
    </div>
    <div className="listItemContent--indicators">
      <Pill warning={!activeCase(record)}>{govRecord(record, 'Status')}</Pill>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/iss-case-claims/views/list-item.jsx